/* Suresh Peddavoora 10/30/2022 2698821717  Added Class Name for Table and Button Enhancement
saikrishna 11/03/2022 2698821717 changed the paginationOptions
Ashraf 11/15/2022 2698821717 fixed role based bugs
Gummala Prakash 11/17/2022 2698821717 Removed search from table.
*/
import React, {useEffect, useState, useContext} from 'react';
// import MaterialTable from "material-table";
import {tableIcons} from '../../../components/TableIcons';
import {Button, TablePagination} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import {useLocation} from 'react-router';
import DialogBox from '../../../components/DialogBox';
import ClientContactForm from './ClientContactForm';
import {ErrorSnackbar, SuccessSnackbar} from '../../../components/CustomSnackBar';
import {useDispatch, useSelector} from 'react-redux';
import {
  fetchDropDowns,
  resetParentClientStatus,
} from '../../../redux/reducers/client-maintainance/ClientContact';
import formatPhoneNumber from '../../../util/PhoneFormat';
import {
  fetchParentClientInfo,
  resetStatus,
  resetToast,
  resetClientData,
} from '../../../redux/reducers/ParentClientContactInfo';
import {defaultRows, tablePageRows} from '../../../constants/ReusableConstants';
import {ThemeContext} from '../../../themes/ThemeProvider';
import DeleteTableRecordPopup from '../../../util/DeleteTableRecordPopup';
import {deleteParentClientContact} from '../../../redux/reducers/ParentClientContactInfo';
import GuiTable from '../../../components/FormComponents/GuiTable';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
const ClientContactInfoTable = ({setContactInfoData, parentClientID}) => {
  const {reusableInputStyles} = useContext(ThemeContext);

  const classes = reusableInputStyles();
  const location = useLocation();
  const parentTableData = location?.state?.parentData && location.state.parentData;
  const [dialog, setDialog] = useState(false);
  // const [deleteDialog, setDeleteDialog] = useState(false);
  const deleteDialog = false;
  const [rowData, setRowData] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const dispatch = useDispatch();
  const {roleData} = useSelector(({role}) => role);
  const disabledByRole = roleData?.window?.['Client Maintenance']?.PC;
  const [rows, setRows] = useState(defaultRows);
  const [tableData, setTableData] = useState([]);
  const {clientContactStatus} = useSelector(({clientContact}) => clientContact);
  useEffect(() => {
    if (clientContactStatus === 200) {
      dispatch(resetParentClientStatus());
    }
  }, [clientContactStatus]);
  const {parentClientData, parentClientSatus, isLoading, errorMsg, successMsg} = useSelector(
    ({parentClientContactInfo}) => parentClientContactInfo,
  );
  const handleDeleteClose = () => {
    setIsDelete(false);
    setRowData({});
  };
  const handleEditRow = (rowData) => {
    setIsEditMode(true);
    setRowData(rowData);
  };
  const handleClose = () => {
    if (isEditMode) {
      setIsEditMode(false);
      setRowData({});
    } else {
      setDialog(false);
    }
  };
  useEffect(() => {
    if (
      parentTableData?.parentClientId ||
      parentClientSatus === 200 ||
      (parentClientSatus === 200 && parentClientID)
    ) {
      dispatch(fetchParentClientInfo(parentTableData?.parentClientId || parentClientID));
      dispatch(resetStatus());
      handleDeleteClose();
      handleClose();
    }
    setTimeout(() => {
      dispatch(resetToast());
    }, 3000);
  }, [parentTableData?.parentClientId, parentClientSatus, parentClientID]);

  useEffect(() => {
    dispatch(fetchDropDowns());
    dispatch(resetClientData());
  }, []);
  const columns = [
    {
      title: 'Contact Type',
      field: 'contactType',
    },
    {
      title: 'Name',
      field: 'contactName',
    },
    {
      title: 'E-mail Address',
      field: 'contactEmailAddress',
    },
    {
      title: 'Phone Number',
      field: 'contactPhoneNumber',
      render: (rowData) => formatPhoneNumber(rowData.contactPhoneNumber),
      customFilterAndSearch: (term, rowData) => {
        const num = formatPhoneNumber(rowData?.contactPhoneNumber)
          ?.toString()
          ?.replace(/\D+/g, '')
          ?.replaceAll(' ', '');

        return (
          rowData?.contactPhoneNumber
            ?.toString()
            ?.replaceAll(' ', '')
            ?.includes(term?.replaceAll(' ', '')) ||
          num?.includes(term) ||
          rowData?.contactPhoneNumber?.toString()?.indexOf(term) > -1
        );
      },
    },
    {
      title: 'Fax Number',
      field: 'contactFaxNumber',
      render: (rowData) => formatPhoneNumber(rowData?.contactFaxNumber),
      customFilterAndSearch: (term, rowData) => {
        const num = formatPhoneNumber(rowData?.contactFaxNumber)
          ?.toString()
          ?.replace(/\D+/g, '')
          ?.replaceAll(' ', '');

        return (
          rowData?.contactFaxNumber
            ?.toString()
            ?.replaceAll(' ', '')
            ?.includes(term?.replaceAll(' ', '')) ||
          num?.includes(term) ||
          rowData?.contactFaxNumber?.toString()?.indexOf(term) > -1
        );
      },
    },
  ];
  const [isDelete, setIsDelete] = useState(false);
  const searchApiData =
    parentClientData && parentClientData.length > 0 ?
      parentClientData.map((item, i) => ({
        ...item,
        id: i,
      })) :
      [];
  const handleSubmit = () => {
    dispatch(deleteParentClientContact(rowData?.parentContactId));
  };
  return (
    <>
      <div className="custom-table global-field-table">
        <DialogBox
          maxWidth={'md'}
          fullWidth
          open={dialog || isEditMode}
          dialogClose={handleClose}
          title={
            (dialog && 'Add Client Contact Information') ||
            (isEditMode && 'Edit Client Contact Information ')
          }
        >
          <ClientContactForm
            handleClose={handleClose}
            isEditMode={isEditMode}
            rowData={rowData}
            setTableData={setTableData}
            setDialog={setDialog}
            tableData={tableData}
            parentClientID={parentClientID}
            formData={searchApiData}
          />
        </DialogBox>
        <DialogBox open={deleteDialog} dialogClose={handleClose}></DialogBox>
        <GuiTable
          icons={tableIcons}
          title="Client Contact Information"
          columns={columns}
          data={searchApiData}
          components={{
            Pagination: (props) => (
              <TablePagination
                {...props}
                SelectProps={{
                  inputProps: {'aria-label': 'Rows per screen'},
                }}
                labelRowsPerPage={'Rows per screen:'}
                rowsPerPageOptions={tablePageRows}
                onChangeRowsPerPage={(event) => {
                  props.onChangeRowsPerPage(event);
                  setRows(event.target.value);
                }}
              />
            ),
          }}
          options={{
            pageSize: rows,
            pageSizeOptions: tablePageRows,
            // actionsColumnIndex: -1,
            sorting: true,
            search: false,
            emptyRowsWhenPaging: false,
            headerStyle: {
              fontWeight: 'bold',
            },
          }}
          isLoading={isLoading}
          onSelectionChange={(rows) => rows}
          actions={[
            {
              icon: () => <EditOutlinedIcon />,
              tooltip: 'Edit',
              disabled: !disabledByRole?.edit,
              onClick: (event, rowData) => handleEditRow(rowData),
            },
            {
              icon: () => <DeleteOutlineOutlinedIcon />,
              tooltip: 'Delete',
              disabled: !disabledByRole?.delete,
              onClick: (event, rowData) => {
                setRowData(rowData);
                setIsDelete(true);
              },
            },
            {
              icon: () => (
                <>
                  <div>
                    <Button
                      variant="outlined"
                      className={`search-btn ${classes.buttonRoot}`}
                      disabled={(!disabledByRole?.edit && parentTableData?.parentClientId) || !disabledByRole?.add}
                    >
                      <AddIcon /> Add
                    </Button>
                  </div>
                </>
              ),
              disabled: (!disabledByRole?.edit && parentTableData?.parentClientId) || !disabledByRole?.add,
              isFreeAction: true,
              onClick: () => setDialog(true),
            },
          ]}
        />
        <DeleteTableRecordPopup
          open={isDelete}
          dialogClose={handleDeleteClose}
          title="Delete Client Contact"
          value={`Do you want to delete the client contact - ${rowData.contactName}?`}
          handleSubmit={handleSubmit}
        />

      </div>
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
};

export default ClientContactInfoTable;
